import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateRangeFilter = ({ startDate, endDate, setStartDate, setEndDate }) => {
  // Function to get first day of current month in local time
  const getFirstDayOfMonth = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  // Function to get last day of current month in local time
  const getLastDayOfMonth = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };

  // Convert to local date without time component
  const toLocalDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };

  // Convert to display date (handles timezone offset)
  const getDisplayDate = (date) => {
    if (!date) return null;
    return toLocalDate(date);
  };

  // Handle start date change
  const handleStartDateChange = (date) => {
    if (!date) return;

    const localDate = toLocalDate(date);
    setStartDate(localDate);

    // Reset end date if it's before the new start date
    if (endDate && localDate > endDate) {
      setEndDate(null);
    }
  };

  // Handle end date change
  const handleEndDateChange = (date) => {
    if (!date) return;

    const localDate = toLocalDate(date);
    // Only set if there's no start date or new date is after start date
    if (!startDate || localDate >= startDate) {
      setEndDate(localDate);
    }
  };


  return (
    <div className="date-range-filter ">
      <span className="filter-date-label">From:</span>
      <span className="date-picker">
        <DatePicker
          selected={getDisplayDate(startDate)}
          onChange={handleStartDateChange}
          maxDate={endDate || getLastDayOfMonth()}
          dateFormat="MMM d, yyyy"
          placeholderText="Start Date"
          className="custom-datepicker"
          dayClassName={(date) => {
            const selectedDate = getDisplayDate(startDate);
            return selectedDate &&
              date.toDateString() === selectedDate.toDateString()
              ? "inline-selected-day"
              : undefined;
          }}
        />

        <style>
          {`
         .inline-selected-day {
          background-color: #383D8D !important; 
          color: white !important;
         }
     
         `}
        </style>

        <i className="bi bi-calendar3 calendar-icon"></i>
      </span>

      <span className="filter-date-label">To:</span>
      <span className="date-picker">
        <DatePicker
          selected={getDisplayDate(endDate)}
          onChange={handleEndDateChange}
          minDate={startDate || getFirstDayOfMonth()}
          maxDate={getLastDayOfMonth()}
          dateFormat="MMM d, yyyy"
          placeholderText="End Date"
          className="custom-datepicker"
          dayClassName={(date) => {
            const selectedDate = getDisplayDate(endDate);
            return selectedDate &&
              date.toDateString() === selectedDate.toDateString()
              ? "inline-selected-day"
              : undefined;
          }}
        />

        <style>
          {`
    .inline-selected-day {
      background-color: #383D8D !important; 
      color: white !important;
    }
   
  `}
        </style>

        <i className="bi bi-calendar3 calendar-icon"></i>
      </span>
    </div>
  );
};

export default DateRangeFilter;
